/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MetricData } from '../models/MetricData';
import type { WorkstreamOutcomesValidationResponse } from '../models/WorkstreamOutcomesValidationResponse';
import type { WorkstreamOutcomesValidationsResponse } from '../models/WorkstreamOutcomesValidationsResponse';
import type { WorkstreamOutcomesValidationStatusResponse } from '../models/WorkstreamOutcomesValidationStatusResponse';
import type { WorkstreamOutcomesValidationTaskResponse } from '../models/WorkstreamOutcomesValidationTaskResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AiWorkstreamOutcomesValidationService {

    /**
     * Get Workstream Outcomes Validations
     * Return all saved outcomes validations for the current tenant.
     * @returns WorkstreamOutcomesValidationsResponse Successful Response
     * @throws ApiError
     */
    public static getWorkstreamOutcomesValidationsApiV1WorkstreamOutcomesValidationsGet(): CancelablePromise<WorkstreamOutcomesValidationsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/outcomes_validations',
        });
    }

    /**
     * Preview Metric Outcomes Validation
     * Generate a preview for an unsaved metric title without workstream context.
     * @param requestBody
     * @returns WorkstreamOutcomesValidationTaskResponse Successful Response
     * @throws ApiError
     */
    public static previewMetricOutcomesValidationApiV1WorkstreamMetricsOutcomesValidationPreviewPost(
        requestBody: MetricData,
    ): CancelablePromise<WorkstreamOutcomesValidationTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/metrics/outcomes_validation/preview',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Generate Metric Outcomes Validation
     * @param workstreamMetricId
     * @returns WorkstreamOutcomesValidationTaskResponse Successful Response
     * @throws ApiError
     */
    public static generateMetricOutcomesValidationApiV1WorkstreamMetricsWorkstreamMetricIdOutcomesValidationGeneratePost(
        workstreamMetricId: number,
    ): CancelablePromise<WorkstreamOutcomesValidationTaskResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/workstream/metrics/{workstream_metric_id}/outcomes_validation/generate',
            path: {
                'workstream_metric_id': workstreamMetricId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Metric Outcomes Validation Preview Status
     * @param taskId
     * @returns WorkstreamOutcomesValidationStatusResponse Successful Response
     * @throws ApiError
     */
    public static getMetricOutcomesValidationPreviewStatusApiV1WorkstreamMetricsOutcomesValidationPreviewTaskIdGet(
        taskId: string,
    ): CancelablePromise<WorkstreamOutcomesValidationStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/metrics/outcomes_validation/preview/{task_id}',
            path: {
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Metric Outcomes Validation Status
     * @param workstreamMetricId
     * @param taskId
     * @returns WorkstreamOutcomesValidationStatusResponse Successful Response
     * @throws ApiError
     */
    public static getMetricOutcomesValidationStatusApiV1WorkstreamMetricsWorkstreamMetricIdOutcomesValidationGenerateTaskIdGet(
        workstreamMetricId: number,
        taskId: string,
    ): CancelablePromise<WorkstreamOutcomesValidationStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/metrics/{workstream_metric_id}/outcomes_validation/generate/{task_id}',
            path: {
                'workstream_metric_id': workstreamMetricId,
                'task_id': taskId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Metric Outcomes Validation
     * @param workstreamMetricId
     * @returns WorkstreamOutcomesValidationResponse Successful Response
     * @throws ApiError
     */
    public static getMetricOutcomesValidationApiV1WorkstreamMetricsWorkstreamMetricIdOutcomesValidationGet(
        workstreamMetricId: number,
    ): CancelablePromise<WorkstreamOutcomesValidationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/workstream/metrics/{workstream_metric_id}/outcomes_validation',
            path: {
                'workstream_metric_id': workstreamMetricId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
